import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useLicensePrice() {
  const { data } = useQuery({
    queryKey: ['license-plan-price'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('billing_plans')
        .select('price_amount, currency, billing_cycle')
        .eq('code', 'pro')
        .eq('active', true)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    staleTime: 1000 * 60 * 30,
  });

  const price = data?.price_amount ?? (data === undefined ? null : 20);
  const currency = data?.currency ?? 'USD';
  const cycle = data?.billing_cycle ?? 'monthly';
  const label = price != null ? `$${price}` : '…';
  const periodLabel = cycle === 'monthly' ? '/mes' : cycle === 'annual' ? '/año' : '';

  return { price, currency, cycle, label, periodLabel, isLoaded: price != null };
}
